import { render, staticRenderFns } from "./GSTStatDet.vue?vue&type=template&id=529fd750&"
import script from "./GSTStatDet.vue?vue&type=script&lang=js&"
export * from "./GSTStatDet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports